<template>
  <div class="container max-w-6xl mx-auto">
    <h1 class="mt-3 font-semibold md:text-2xl text-stone-700">
      New Projects in Ghana
    </h1>
    <div class="flex justify-between w-full mt-8">
      <p class="text-sm font-light text-stone-500">
        {{ projectCount }} projects
      </p>
      <div class="flex items-center">
        <p class="mr-1 text-sm text-stone-500">Sort by:</p>
        <DropDown
          height="[35px]"
          buttonLabel="Featured"
          :menu-items="propertyFilters"
          radius="lg"
          unique-identifier="filters"
          @menu-item-selected="handleMenuItemSelected"
        />
      </div>
    </div>
    <div class="px-3 mt-8">
      <vue-horizontal
        responsive
        class="horizontal"
        :displacement="0.7"
        snap="center"
      >
        <div class="flex flex-row space-x-5">
          <div
            v-for="city in citiesCount"
            :key="city.id"
            :class="[
              'w-auto h-8 px-4 text-center border border-gray-200 rounded-md',
              selectedCityId === city.id
                ? 'bg-secondary text-white'
                : 'bg-gray-50 text-stone-600',
            ]"
          >
            <button @click="selectCity(city.id)" class="text-sm">
              {{ city.name }} ({{ city.properties_count }} projects)
            </button>
          </div>
        </div>
      </vue-horizontal>
    </div>
    <ProjectCard :projects="projects" class="mt-8" />
  </div>
</template>
<script>
import { ref, reactive, watch } from "vue";
import { useStore } from "vuex";
import DropDown from "@/components/form-components/DropDown.vue";
import VueHorizontal from "vue-horizontal";
import ProjectCard from "./ProjectCard.vue";

export default {
  name: "BuyProperties",
  props: {
    projects: Object,
    citiesCount: Array, // Ensure citiesCount is an array
    projectCount: Number,
  },
  components: {
    DropDown,
    VueHorizontal,
    ProjectCard,
  },
  emits: ["get-properties-by-city-id", "project-sorting"],
  setup(props, { emit }) {
    const store = useStore();

    const isDropdownOpen = ref(false);
    const propertyFilters = reactive({
      ...store.state.propertyFilters,
    });
    const selectedCityId = ref(null);

    // console.log("selectedCityId initialized:", selectedCityId.value);

    const handleMenuItemSelected = (sort_by) => {
      emit("project-sorting", sort_by);
    };

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const selectCity = (cityId) => {
      selectedCityId.value = cityId;
      // console.log(
      //   "City selected:",
      //   cityId,
      //   "selectedCityId:",
      //   selectedCityId.value
      // );
      emit("get-properties-by-city-id", cityId);
    };

    watch(selectedCityId, (newValue) => {
      console.log("selectedCityId updated:", newValue);
    });

    return {
      selectedCityId,
      selectCity,
      handleMenuItemSelected,
      isDropdownOpen,
      propertyFilters,
      toggleDropdown,
    };
  },
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}

.horizontal >>> .v-hl-btn-prev {
  clip-path: none !important;
  padding-right: 24px;
}

.horizontal >>> .v-hl-btn-next {
  clip-path: none !important;
  padding-left: 24px;
}

.horizontal >>> .v-hl-btn {
  top: 0;
  bottom: 0;
  transform: translateX(0);
}
</style>
